import { ArrowLeft, Search } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import AppHeader from '../components/AppHeader';
import EvaluationListRow from '../components/EvaluationListRow';
import StatusMessage from '../components/StatusMessage';
import { useAsignaciones } from '../hooks/useAsignaciones';
import AppPageLayout from '../layout/AppPageLayout';
import { useEvaluationStore } from '../store/evaluationStore';

function ListadoEvaluacionesPage() {
  const navigate = useNavigate();
  const iniciarEvaluacion = useEvaluationStore((state) => state.iniciarEvaluacion);
  const creandoInforme = useEvaluationStore((state) => state.creandoInforme);
  const errorInforme = useEvaluationStore((state) => state.errorInforme);
  const successInforme = useEvaluationStore((state) => state.successInforme);
  const { asignaciones, loading, error } = useAsignaciones('trianual');
  const [search, setSearch] = useState('');
  const [pendingEvaluado, setPendingEvaluado] = useState(null);

  const evaluaciones = asignaciones;

  const filteredEvaluaciones = useMemo(() => {
    const query = search.trim().toLowerCase();

    if (!query) {
      return evaluaciones;
    }

    return evaluaciones.filter((item) =>
      `${item.nombre} ${item.legajo} ${item.examen}`.toLowerCase().includes(query)
    );
  }, [evaluaciones, search]);

  const handleSelectEvaluation = async (evaluado) => {
    setPendingEvaluado(evaluado);

    try {
      const firstQuestionId = await iniciarEvaluacion(evaluado);
      navigate(`/evaluaciones-trianuales/preguntas/${firstQuestionId}`);
    } catch (err) {
      return err;
    }
  };

  return (
    <AppPageLayout>
      <AppHeader />

      <div className="mx-auto mt-10 w-full max-w-[760px] lg:mt-12">
        <h1 className="text-center font-login text-[30px] font-bold leading-tight text-[#30343b] sm:text-[36px]">
          Evaluaciones Trianuales
        </h1>

        <div className="mt-8 border-t border-[#eceff3] pt-6">
          <button
            type="button"
            onClick={() => navigate('/evaluaciones-trianuales')}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full text-[#111111] transition hover:bg-[#f5f7fa]"
            aria-label="Volver"
          >
            <ArrowLeft className="h-5 w-5" strokeWidth={2.8} />
          </button>

          <div className="mt-5 flex overflow-hidden rounded-[8px] border border-[#d7dce2] bg-white shadow-sm">
            <input
              type="text"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Buscar"
              className="h-11 flex-1 border-0 px-4 font-login text-[14px] text-[#374151] outline-none placeholder:text-[#9aa3ad]"
            />
            <button
              type="button"
              aria-label="Buscar"
              className="flex h-11 w-12 items-center justify-center bg-[#67bb49] text-white"
            >
              <Search className="h-4 w-4" strokeWidth={2.8} />
            </button>
          </div>

          <div className="mt-5 overflow-hidden rounded-[10px] border border-[#dce2e8] bg-white">
            <div className="grid grid-cols-[1.5fr_1fr_1fr] gap-3 border-b border-[#dce2e8] bg-[#f7f8fa] px-3 py-3">
              <span className="font-login text-[11px] font-bold text-[#30343b] sm:text-[12px]">
                Nombre
              </span>
              <span className="font-login text-[11px] font-bold text-[#30343b] sm:text-[12px]">
                Legajo
              </span>
              <span className="font-login text-[11px] font-bold text-[#30343b] sm:text-[12px]">
                Examen a realizar
              </span>
            </div>

            <div className="divide-y divide-[#dce2e8]">
              {loading ? (
                <p className="px-4 py-5 font-login text-[14px] text-[#5f6673]">
                  Cargando asignaciones...
                </p>
              ) : null}

              {!loading && !error && !filteredEvaluaciones.length ? (
                <p className="px-4 py-5 font-login text-[14px] text-[#5f6673]">
                  No hay asignaciones para mostrar.
                </p>
              ) : null}

              {filteredEvaluaciones.map((item) => (
                <EvaluationListRow
                  key={item.id}
                  nombre={item.nombre}
                  legajo={item.legajo}
                  examen={item.examen}
                  onClick={() => handleSelectEvaluation(item)}
                />
              ))}
            </div>
          </div>

          <StatusMessage
            loading={creandoInforme}
            error={error || errorInforme}
            success={successInforme}
            onRetry={
              pendingEvaluado ? () => handleSelectEvaluation(pendingEvaluado) : undefined
            }
          />
        </div>

        <div className="pt-10 text-center font-login text-[10px] text-[#5f6673]">
          <p>Copyright 2022 JPH Lions Todos los derechos reservados</p>
        </div>
      </div>
    </AppPageLayout>
  );
}

export default ListadoEvaluacionesPage;
